import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL_PRODUCTS,  
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Oc-Merchant-Id': process.env.VUE_APP_MERCHANT_ID
  },
  timeout: 60000
})

export default {
  async getProducts() {
    return await apiClient.get('/get_deals');
  }
}